// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".producttecdetails__definition-table{width:100%}.producttecdetails__definition-table td,.producttecdetails__definition-table th{vertical-align:top;padding-top:.4rem;padding-bottom:.4rem}.producttecdetails__definition-head{text-align:left;font-weight:400}.producttecdetails__definition-footer small{display:block}.producttecdetails__definition-footer small:first-child{padding-top:2rem}", ""]);
// Exports
module.exports = exports;
